const engChars = {
    "Ğ": "G",
    "Ü": "U",
    "Ş": "S",
    "İ": "I",
    "Ö": "O",
    "Ç": "C",
    "ğ": "g",
    "ü": "u",
    "ş": "s",
    "ı": "i",
    "ö": "o",
    "ç": "c"
};
const STRING_HELPER = {
    getStringEN(str) {
        try {
            return [...str].map(c => engChars[c] || c).join("");
        } catch (e) {
            return '';
        }
    },
    capitalizeFirstLetter(string) {
        try {
            return string.charAt(0).toUpperCase() + string.slice(1);
        } catch (e) {
            return ''
        }
    },
    isEmailValid(email) {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    },
    hexToRgba(hex, alpha) {
        // Remove the hash at the start if it's there
        hex = hex?.replace(/^#/, '');

        // Parse the hex values into RGB components
        let r = parseInt(hex?.substring(0, 2), 16);
        let g = parseInt(hex?.substring(2, 4), 16);
        let b = parseInt(hex?.substring(4, 6), 16);

        // Return the RGBA string
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    adjustBrightness(hex, percent) {
        try {
            // Convert hex to RGB
            let r = parseInt(hex.slice(1, 3), 16);
            let g = parseInt(hex.slice(3, 5), 16);
            let b = parseInt(hex.slice(5, 7), 16);

            // Adjust each color channel
            r = Math.min(255, Math.max(0, Math.floor(r + (r * percent / 100))));
            g = Math.min(255, Math.max(0, Math.floor(g + (g * percent / 100))));
            b = Math.min(255, Math.max(0, Math.floor(b + (b * percent / 100))));

            // Convert back to hex and ensure two-digit format for each value
            const toHex = (value) => value.toString(16).padStart(2, '0');

            // Return adjusted color in hex format
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        } catch (e) {
            console.error(e)
            return ''
        }
    },
    getLocalizedPath(lang, path) {
        return lang ? `/${lang}${path}` : path; // Prepend the language if it's defined
    },
    getModalPath(type, searchParams) {
        const params = new URLSearchParams(searchParams);
        params.set('modal', type);
        return `?${params.toString()}`;
    },

    getModalPathWithTab(type, tab, searchParams) {
        const params = new URLSearchParams(searchParams);
        params.set('modal', type);
        params.set('tab', tab);
        return `?${params.toString()}`;
    },

    getModalPathStatistics(type, username, searchParams) {
        const params = new URLSearchParams(searchParams);
        params.set('modal', type);
        if (username)
            params.set('user', username);
        return `?${params.toString()}`;
    },
    getModalPathRace(type, uuid, searchParams) {
        const params = new URLSearchParams(searchParams);
        params.set('modal', type);
        if (uuid)
            params.set('uuid', uuid);
        return `?${params.toString()}`;
    },
    getModalPathBonus(type, reference, searchParams) {
        const params = new URLSearchParams(searchParams);
        params.set('modal', type);
        if (reference)
            params.set('reference', reference);
        return `?${params.toString()}`;
    },

    slugify(text) {
        return text
            .toString()
            .toLowerCase()
            .trim()
            .normalize("NFD") // Normalize accented characters
            .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
            .replace(/[^a-z0-9 -]/g, "") // Remove invalid characters
            .replace(/\s+/g, "-") // Replace spaces with hyphens
            .replace(/-+/g, "-"); // Remove duplicate hyphens
    },

    formatLabel(str) {
        try {
            return str
                .replace(/-/g, ' ') // Replace hyphens with spaces
                .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize each word
        } catch (e) {
            return str
        }
    }
}


export default STRING_HELPER
